import { getDatabaseContainerType, useAnalytics } from '@databases/analytics';
import { type ContentSelectionMode } from '@databases/redux/cellSelections/selectors';
import { type ActionType } from '@databases/types/database';
import { type SelectionMode } from '@databases/types/database';
import { useCallback } from 'react';

import { ContentSelectionModeMap } from '../constants';

export type OnCloseActionBarTypes = {
  contentId: string;
  count: number;
  selectionMode: ContentSelectionMode;
  entryId: string;
};

export type OnSelectActionItemTypes = {
  type: ActionType;
  contentId: string;
  totalSelectedCount: number;
  selectionMode: SelectionMode;
  isSingleSelectedEntry: boolean;
  entryId: string;
};

export const useActionBarAnalytics = () => {
  const analyticsClient = useAnalytics();
  const databaseContainer = getDatabaseContainerType();

  const onCloseActionBar = useCallback(
    ({ contentId, count, selectionMode, entryId }: OnCloseActionBarTypes) => {
      analyticsClient.sendSelectedActionItemEvent({
        type: 'close',
        databaseContainer,
        contentId,
        selectedCount: count,
        selectionMode: ContentSelectionModeMap[selectionMode],
        ...(count === 1 &&
          selectionMode === 'row' &&
          entryId && {
            entryId,
          }),
      });
    },
    [analyticsClient, databaseContainer]
  );

  const onSelectActionItem = useCallback(
    ({
      type,
      contentId,
      totalSelectedCount,
      selectionMode,
      isSingleSelectedEntry,
      entryId,
    }: OnSelectActionItemTypes) => {
      analyticsClient.sendSelectedActionItemEvent({
        type,
        databaseContainer,
        contentId,
        selectedCount: totalSelectedCount,
        selectionMode: selectionMode,
        ...(isSingleSelectedEntry && entryId && { entryId }),
      });
    },
    [analyticsClient, databaseContainer]
  );

  return {
    onCloseActionBar,
    onSelectActionItem,
  };
};
